import React from 'react';
import { renderNpcPortraitSvg } from '../../rendering/npc/npcArtSeams';
import { normalizePortraitSize } from '../../rendering/svg/scopeSvgIds';

export interface NpcPortraitProps {
  npcId?: string;
  npcType?: string;
  name: string;
  size?: number;
  /** `talk`/`gesture` while a conversation is open (Pip/Mallow wardrobe poses); others ignore it. */
  pose?: 'idle' | 'talk' | 'gesture';
}

/** Preserve the same authored hair, clothing and props as the world NPC
 *  (bust-framed for NPCs on the plan-12 art profile). */
export const NpcPortrait: React.FC<NpcPortraitProps> = ({ npcId, npcType, name, size = 120, pose = 'idle' }) => {
  const namespace = `npc-portrait-${React.useId().replace(/[^a-zA-Z0-9_-]/g, '-')}`;
  const renderSize = normalizePortraitSize(size);
  const svg = renderNpcPortraitSvg(npcId, npcType, renderSize, namespace, pose);
  return <div
    className="npc-portrait ghost-generator"
    role="img"
    aria-label={`${name} portrait`}
    style={{ width: renderSize, height: renderSize }}
    dangerouslySetInnerHTML={{ __html: svg }}
  />;
};
